module.exports = __webpack_public_path__ + "img/pagarme-current.c38be719.svg";